















































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, TextField, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import Autocomplete from '@/components/molecules/Autocomplete/Autocomplete.vue';

import eventBus from '@/utils/eventBus';

@Component({
  components: {
    Surface,
    Typography,
    TextField,
    Picture,
    FilledButton,
    Autocomplete
  }
})
export default class OtherCountryModal extends Vue {
  onClose() {
    eventBus.$emit('closeModal');
    eventBus.$emit('resetSignupCountrySelect');
  }
}
